import React, { useEffect, useState } from 'react';
import { Loader2, Zap } from 'lucide-react';
import { useSelector } from 'react-redux';
import { use } from 'react';

const SubmittingStep = ({ onComplete, loading }) => {
  const [statusIndex, setStatusIndex] = useState(0);
  
  // Minimal, professional status messages
  const statuses = [
    { title: "Submitting Data", sub: "Sending your details to the CampusIRA network." },
    { title: "Personalizing Your Feed", sub: "Configuring interview paths and campus reviews." },
    { title: "Finalizing Account", sub: "Wrapping up and launching your dashboard." }
  ];

  // Simple 3-second timer to simulate the API call
  useEffect(() => {
    // Cycle through status messages
    onComplete();
    const statusInterval = setInterval(() => {
      setStatusIndex((prev) => {
        if (prev < statuses.length - 1) {
          return prev + 1;
        }
        return prev; // Keep it at the last index if finished
      });
    }, 2000);

    // Call onComplete after 3 seconds to move to Success screen
    return () => {
      clearInterval(statusInterval);
    };
  }, []);

  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center w-full max-w-lg mx-auto animate-in fade-in duration-500">
      
      {/* Cool, Animated Loader Icon (Central Element) */}
      <div className="relative mb-12">
        {/* Outer pulsating glow effect */}
        <div className="absolute inset-0 bg-blue-500/10 rounded-full blur-3xl scale-150 animate-pulse"></div>
        
        {/* The Loader: Using Loader2 from Lucide, rotating */}
        <div className="relative z-10 p-5 bg-white rounded-full shadow-2xl shadow-blue-500/10 border border-blue-50 flex items-center justify-center">
          <Loader2 
            size={64} 
            className="text-blue-600 animate-spin-slow" 
            strokeWidth={1.5}
          />
          {/* Subtle icon in the very center, static */}
          <div className="absolute inset-0 flex items-center justify-center">
            <Zap size={24} className="text-blue-400 opacity-60" fill="currentColor" strokeWidth={1} />
          </div>
        </div>
      </div>

      {/* Dynamic Status Text (Perfect and Minimal) */}
      <div className="space-y-3 min-h-[80px]"> {/* Fixed height prevents layout shift */}
        <h2 className="text-3xl font-black text-gray-900 tracking-tight animate-in slide-in-from-bottom-2 duration-300">
          {statuses[statusIndex].title}
        </h2>
        <p className="text-base text-gray-500 max-w-sm mx-auto leading-relaxed animate-in fade-in delay-100">
          {statuses[statusIndex].sub}
        </p>
      </div>

      {/* Architect's Small Label (Subtle Branding) */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2">
        <span className="text-[10px] font-black uppercase tracking-[0.3em] text-gray-300">
          CampusIRA Build v1.0
        </span>
      </div>
    </div>
  );
};

export default SubmittingStep;